import axios from 'axios';
import theme from '../themes/ThemeLoader'

const PROD_URL = theme.environments.production.baseUrl;
//const DEV_URL = theme.environments.development.baseUrl;
const ENABLE_API_LOGS = false;

export const api = axios.create({baseURL: PROD_URL});

if (ENABLE_API_LOGS) {
    api.interceptors.request.use(
        (config) => {
            try {
                console.log('[API][Request]', (config.method || '').toUpperCase(), config.url, config);
            } catch (e) {
                console.log('[API][Request] (log error)', e);
            }
            return config;
        },
        (error) => {
            console.error('[API][Request][Error]', error);
            return Promise.reject(error);
        }
    );

    api.interceptors.response.use(
        (response) => {
            try {
                console.log('[API][Response]', response.status, response.config.method?.toUpperCase(), response.config.url, response);
            } catch (e) {
                console.log('[API][Response] (log error)', e);
            }
            return response;
        },
        (error) => {
            console.error('[API][Response][Error]', error);
            return Promise.reject(error);
        }
    );
}

export const AuthenticateUser = async (username, password, access) => {
    const body = {
        username : username,
        password : password,
        access : access,
    }
    return api.post("/api/auth/login", body)
}

export const createUser = async (userData) => {
    const body = {
        name : userData.name,
        username : userData.username,
        password : userData.password,
        phone : userData.phone,
        role : userData.role,
        access : userData.access,
        storeIds : userData.storeIds,
    }
    return api.post("/api/users/register", body)
}

export const getUsers = async () => {
    return api.get("/api/users/findusers")
}

export const getUsersByStoreId = async (storeId) => {
    return api.get(`/api/users/findusers/${storeId}`)
}

export const getUsersByStoreIdV2 = async (storeId) => {
    return api.get(`/api/users/findusersv2/${storeId}`)
}

export const deleteUser = async (userId) => {
    return api.delete(`/api/users/deleteuser/${userId}`);
}

export const updateUser = async (userData) => {
    const body = {
        name: userData.name,
        username: userData.username,
        password: userData.password,
        phone: userData.phone,
        role: userData.role,
        access : userData.access,
        storeIds : userData.storeIds
    };

    return api.put(`/api/users/updateuser/${userData.id}`, body);
}

export const createProduct = async (productData) => {
    const body = {
        barcode : productData.barcode,
        name : productData.name,
        manufacturer : productData.manufacturer,
        group : productData.group,
        storeIds : productData.storeIds,
    }

    return api.post("/api/products/register", body)
}

export const getProductsByStoreId = async (storeId, page, limit) => {
    return api.get(`/api/products/findproducts/${storeId}`, {
        params: { page, limit },
    });
};

export const exportProductsByStore = async (storeIds) => {
    const body = {
        storeIds : storeIds
    }

    return api.post("/api/products/exportproducts", body)
};

export const importProducts = async (importData) => {
    const body = importData
    return api.post("/api/products/importproducts", body)
};

export const searchProductsForStore = async (storeId, query) => {
    return api.get(`/api/products/search/${storeId}`, {
        params: { query },
    });
};

export const deleteProducts = async (productIds) => {
    const body = {
        productIds : productIds,
    }
    return api.delete("/api/products/deleteproducts", { data: body });
}

export const deleteAllproducts = async (storeId) => {
    return api.delete(`/api/products/deleteallproducts/${storeId}`);
}

export const updateProduct = async (productData) => {
    const body = {
        barcode : productData.barcode,
        name : productData.name,
        manufacturer : productData.manufacturer,
        group : productData.group,
        storeIds : productData.storeIds,
    }
    return api.put(`/api/products/updateproduct/${productData.id}`, body);
}

export const getStores = async () => {
    return api.get("/api/stores/findstores")
}

export const createStore = async (name, description, cnpj, phone) => {
    const body = {
        name : name,
        description : description,
        cnpj : cnpj,
        phone : phone,
    }
    return api.post("/api/stores/createstore", body)
}

export const deleteStore = async (storeId) => {
    return api.delete(`/api/stores/deletestore/${storeId}`);
}

export const updateStore = async (storeData) => {
    const body = {
        name: storeData.name,
        description: storeData.description,
        cnpj: storeData.cnpj,
        phone: storeData.phone,
    };
    return api.put(`/api/stores/updatestore/${storeData.id}`, body);
}

export const getTemplates = async () => {
    return api.get("/api/templates/findtemplates")
}

export const createTemplate = async (templateData) => {
    const body = {
        templateName : templateData.templateName,
        barcode : templateData.barcode,
        productName : templateData.productName,
        manufacturer : templateData.manufacturer,
        group : templateData.group,
        line : templateData.line,
    }
    return api.post("/api/templates/register", body)
}

export const deleteTemplate = async (id) => {
    return api.delete(`/api/templates/deletetemplate/${id}`);
}

export const updateTemplate = async (templateData) => {
    const body = {
        templateName : templateData.templateName,
        barcode : templateData.barcode,
        productName : templateData.productName,
        manufacturer : templateData.manufacturer,
        group : templateData.group,
        line : templateData.line,
    }
    return api.put(`/api/templates/updatetemplate/${templateData.id}`, body);
}

export const postProductStatus = async (productStatusData) => {
    const body = {
        storeId : productStatusData.storeId,
        items : productStatusData.items,
    }
    return api.post("/api/productstatus/createproductstatus", body)
}

export const getProductStatus = async (storeId) => {
    return api.get(`/api/productstatus/findproductstatus/${storeId}`)
}

export const getExpiredProductsByStore = async (storeId, page, limit) => {
    return api.post(`/api/expiredproduct/findbystore`, { 
        storeId  
    }, {
      params: {
        page,
        limit,
      },
    });
  };

export const searchExpiredProductsForStore = async (storeId, query) => {
return api.get(`/api/expiredproduct/search/${storeId}`, {
        params: { query },
    });
};

export const exportExpiredProductsByStores = async (storeIds) => {
    const body = {
        storeIds : storeIds
    }
    return api.post("/api/expiredproduct/exportexpiredproducts", body)
};

export const filterExpiredProducts = async (filterData, page, limit) => {
  const body = {
    storeId: filterData.storeId,
    userIds: filterData.userIds,
    barcode: filterData.barcode,
    name: filterData.name,
    manufacturer: filterData.manufacturer,
    lot: filterData.lot,
    expirationDate: filterData.expirationDate,
    daysToExpire: filterData.daysToExpire,
    group: filterData.group,
    quantity: filterData.quantity,
    quantityLost: filterData.quantityLost,
    quantitySold: filterData.quantitySold,
    balance: filterData.balance,
    statusColors: filterData.statusColors,
    location: filterData.location
  };

  return api.post("/api/expiredproduct/filter",body, {
    params: {
      page,
      limit,
    },
  });
};

export const putExpiredProduct = async (expiredProductData) => {
    const body = {
        productId : expiredProductData.productId,
        userId : expiredProductData.userId,
        storeId : expiredProductData.storeId,
        quantity : expiredProductData.quantity,
        quantitySold : expiredProductData.quantitySold,
        quantityLost : expiredProductData.quantityLost,
        balance : expiredProductData.balance,
        expirationDate : expiredProductData.expirationDate,
        lot : expiredProductData.lot,
        location : expiredProductData.location,
    }
    return api.put(`/api/expiredproduct/update/${expiredProductData.id}`, body);
}

export const deleteExpiredProducts = async (expiredProductIds) => {
    const body = {
        expiredProductIds : expiredProductIds,
    }
    return api.delete("/api/expiredproduct/delete", { data: body });
}

export const deleteExpiredProductsByStore = async (storeId) => {
    return api.delete(`/api/expiredproduct/deleteall/${ storeId }`);
}

export const transferExpiredProducts = async (transferData) => {
    const body = {
        fromUserId : transferData.fromUserId,
        toUserId : transferData.toUserId,
        expiredProductIds : transferData.expiredProductIds,
    }
    return api.put("/api/expiredproduct/transfer", body);
}

export const findMasterUsersByClientId = async (clientId) => {
    return api.get(`/api/users/findmasterusers/${clientId}`)
}

export const createMasterUser = async (clientId, userData) => {
    const body = {
        name : userData.name,
        username : userData.username,
        password : userData.password,
        phone : userData.phone,
        role : userData.role,
        access : userData.access,
    }
    return api.post(`/api/users/createmasteruser/${clientId}`, body)
}

export const updateMasterUser = async (clientId, userData) => {
    const body = {
        name : userData.name,
        username : userData.username,
        password : userData.password,
        phone : userData.phone,
        role : userData.role,
        access : userData.access,
    }
    return api.put(`/api/users/updatemasteruser/${clientId}/${userData.id}`, body)
}

export const deleteMasterUser = async (clientId, userId) => {
    return api.delete(`/api/users/deletemasteruser/${clientId}/${userId}`);
}